import { z } from "zod"

export const goodsReceiptFormSchema = z.object({
  trackingNumbers: z.array(z.string().max(50, "Container/Tracking# must not exceed 50 characters")).optional(),
  estimatedDeliveryOn: z.string().nullable().optional(),
  deliveryLocation: z.object(
    {
      id: z.string().min(1, "Delivery Location is required"),
      label: z.string(),
    },
    {
      required_error: "Delivery Location is required",
    }
  ),
  estimatedPallets: z
    .union([z.string(), z.number()])
    .optional()
    .transform((val) => {
      if (typeof val === "string" && val.trim() === "") return undefined
      if (typeof val === "string") return parseInt(val, 10)
      return val
    })
    .refine((val) => val === undefined || (Number.isInteger(val) && val > 0), {
      message: "Estimated Pallets must be a positive integer",
    }),
  supplier: z
    .object({
      id: z.string(),
      label: z.string(),
    })
    .optional(),
})

export type GoodsReceiptFormValues = z.infer<typeof goodsReceiptFormSchema>

export const incomingPurchaseOrderLineFormSchema = z.object({
  purchaseOrderLineId: z.string(),
  palletsCount: z.number().nullable(),
  unitsCount: z.number().nullable(),
  quantity: z.number().nullable(),
  uomId: z.string(),
})

export const incomingPurchaseOrderFormSchema = z.object({
  purchaseOrderId: z.number(),
  lines: z.array(incomingPurchaseOrderLineFormSchema),
})

export const incomingPurchaseOrdersFormSchema = z.object({
  goodsReceiptId: z.string(),
  purchaseOrders: z.array(incomingPurchaseOrderFormSchema),
})

export type IncomingPurchaseOrdersFormValues = z.infer<typeof incomingPurchaseOrdersFormSchema>

export type IncomingPurchaseOrderLineFormValues = z.infer<typeof incomingPurchaseOrderLineFormSchema>

export type IncomingPurchaseOrderFormValues = z.infer<typeof incomingPurchaseOrderFormSchema>
